const share_comp_list = document.querySelectorAll('.js_share_comp')

if (share_comp_list.length) {
  function openShareSec (shareEl) {
    shareEl.classList.add('open')
  }

  function closeOnClickOutside (element) {

    //
    const outsideClickListener = event => {
      if (!element.contains(event.target) && isVisible(element)) { // or use: event.target.closest(selector) === null
        element.closest('.js_share_comp').classList.remove('open')
        removeClickListener()
      }
    }

    const removeClickListener = () => {
      document.removeEventListener('click', outsideClickListener)
    }


    document.addEventListener('click', outsideClickListener)
  }

  const isVisible = elem => !!elem && !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length) // source (2018-03-11): https://github.com/jquery/jquery/blob/master/src/css/hiddenVisibleSelectors.js

  for (var i = 0; i < share_comp_list.length; i++) {
    let outsideClick
    const shareEl = share_comp_list[i]
    const shareElInfoBtn = shareEl.querySelector('.js_share_info_btn')

    shareElInfoBtn.addEventListener('click', () => {
      openShareSec(shareEl)
      closeOnClickOutside(shareEl)
    })

    const shareLinks = shareEl.querySelectorAll('.share-link');
    shareLinks.forEach((link) => {
      link.addEventListener('click', (e) => {

        const platformClass = link.querySelector('.share-link-icon').className;
        const platform = platformClass.includes('icon-') ? platformClass.split('icon-')[1] : 'unknown-platform';
        const recipeName = document.querySelector('h1').textContent.trim();
        const linkUrl = link.href;

        const gtmEvent = {
          trigger: 'share recipes',
          event_id: '1.8',
          event: 'share',
          link_url: linkUrl,
          event_campaign: 'general',
          content_type: 'recipe',
          content_id: recipeName,
          category: 'recipes',
          market: window.getMarketFromUrl(),
          method: platform
        };

        window.dataLayer.push(gtmEvent);
      });
    });

  }
}





